// components/features/orders/OrdersList.tsx
import { Order } from "@cabukaka/types";
import TableList, { SelectAction } from "../../ui/TableList";
import OrderRow from "./OrderRow";

interface OrdersListProps {
  orders: Order[];
  onAction: (order: Order) => void;
  onSelectOrders?: (selectedOrders: Order[]) => void;
  selectable?: boolean;
  selectActions?: SelectAction[];
}

export default function OrdersList({
  orders,
  onAction,
  onSelectOrders,
  selectable = false,
  selectActions
}: OrdersListProps) {
  const columns = [
    { header: "Référence", className: "w-1/5" },
    { header: "Client", className: "hidden sm:table-cell w-1/5" },
    { header: "Total", className: "hidden sm:table-cell w-1/6" },
    { header: "Statut", className: "w-1/6" },
    { header: "Paiement", className: "hidden md:table-cell w-1/6" },
    { header: "Date", className: "hidden lg:table-cell w-1/6" },
  ];

  return (
    <TableList
      items={orders}
      columns={columns}
      getId={(order) => order.id}
      onAction={onAction}
      onSelectItems={onSelectOrders}
      selectable={selectable}
      emptyMessage="Aucune commande trouvée"
      actionColumn={true}
      selectActions={selectActions}
      renderRow={(order, isSelected, onSelect) => (
        <OrderRow
          key={order.id}
          order={order}
          onAction={onAction}
          onSelect={onSelect}
          isSelected={isSelected}
          selectable={selectable}
        />
      )}
    />
  );
}